const cgSpecificCountries = [
  {
    name: "Australia",
    code: "Australia",
    country_code: "AUS",
    two_letter_country_code: "AU",
  },
];

module.exports = cgSpecificCountries;
